export default "__VITE_ASSET__13riJUH3__"